import { Segment } from "semantic-ui-react";

export default function FlexTableExpander({ onClick, expanded, collapsedText, expandedText }) {
	return (
		<Segment secondary textAlign="center" style={{ cursor: "pointer" }} onClick={onClick}>
			{expanded ? expandedText : collapsedText}
		</Segment>
	);
}
